// extracted by mini-css-extract-plugin
export var fadeIn = "_mj-1";
export var modalContent = "_mj-3";
export var overlay = "_mj-0";
export var popoverContent = "_mj-2";
export var results = "_mj-5";
export var searchInputWrapper = "_mj-4";